/**
 * R.H.I.E. - Ritual & Habit Intelligence Engine
 * P2 - AI Öneri Motoru, Drop Risk Analizi, Seviye Bazlı Rehber
 * Merkezi Motor - Ritüel, Gamification, AI ve Davranış Senkronizasyonu
 */

import { rhieEventBus, RHIE_EVENTS, DROP_RISK_LEVELS, GUIDE_INTENSITY } from './zihinKilavuzuEventBus';

const API_URL = process.env.REACT_APP_BACKEND_URL;

// ==========================================
// SEVİYE BAZLI REHBER MESAJLARI (P2 Genişletilmiş)
// ==========================================

const GUIDE_MESSAGES = {
  // === RİTÜEL OLAYLARI ===
  [RHIE_EVENTS.RITUAL_STARTED]: {
    Farkındalık: { title: 'Başladın... ∗', body: 'Derin nefes al… ve başla. Ses sana eşlik ederken… zihnin açılacak.', duration: 5000 },
    Uyanış: { title: 'Hazırsın', body: 'Bu ritüel… senden sadece birkaç dakika ister.', duration: 4000 },
    Dönüşüm: { title: 'Başla', body: 'Ritüelin aktif.', duration: 3000 },
    Ustalık: null,
    Mentor: null
  },
  [RHIE_EVENTS.RITUAL_COMPLETED]: {
    Farkındalık: { title: 'Harika ✧', body: 'Bugünün ritüelini tamamladın... Her adım seni dönüştürüyor.', duration: 6000 },
    Uyanış: { title: 'Tamamlandı ◇', body: 'Ritüel sürekliliğin uzadı... böyle devam.', duration: 4000 },
    Dönüşüm: { title: 'İşte bu', body: 'Bir adım daha.', duration: 3000 },
    Ustalık: { title: '✓', body: null, duration: 2000 },
    Mentor: null
  },
  [RHIE_EVENTS.RITUAL_SKIPPED]: {
    Farkındalık: { title: 'Bugün durdun ◇', body: 'Bugün durdun… yarın daha bilinçli başlayabilirsin. Kendine izin ver.', duration: 5000 },
    Uyanış: { title: 'Hazırsan', body: 'Hazırsan buradayız.', duration: 3000 },
    Dönüşüm: null,
    Ustalık: null,
    Mentor: null
  },
  
  // === RİTÜEL SÜREKLİLİĞİ OLAYLARI ===
  [RHIE_EVENTS.STREAK_EXTENDED]: {
    Farkındalık: { title: 'Ritüel sürekliliği uzadı ◇', body: (data) => `${data.currentStreak} günlük süreklilik... Tutarlılık, dönüşümün anahtarı.`, duration: 5000 },
    Uyanış: { title: 'Süreklilik +1 ◇', body: 'Momentum seninle...', duration: 4000 },
    Dönüşüm: { title: '+1', body: null, duration: 2000 },
    Ustalık: null,
    Mentor: null
  },
  [RHIE_EVENTS.STREAK_BROKEN]: {
    Farkındalık: { title: 'Bu düşüş değil ◇', body: 'Ritüel sürekliliği kırıldı… fakat niyetin devam ediyor. Bu düşüş… yolun sonu değil… yeni başlangıç.', duration: 6000 },
    Uyanış: { title: 'Yeniden başla', body: 'Aynı yere değil… daha bilinçli geri dön.', duration: 4000 },
    Dönüşüm: { title: 'Devam', body: 'Bugün yeni bir gün.', duration: 3000 },
    Ustalık: null,
    Mentor: null
  },
  [RHIE_EVENTS.STREAK_AT_RISK]: {
    Farkındalık: { title: 'Sürekliliğini koru ◈', body: 'Bugün henüz ritüelini tamamlamadın. Şimdi… kendine izin ver… ve derinleş.', duration: 7000 },
    Uyanış: { title: 'Hatırlatma', body: 'Bugün ritüel eksik.', duration: 4000 },
    Dönüşüm: null,
    Ustalık: null,
    Mentor: null
  },
  [RHIE_EVENTS.STREAK_MILESTONE]: {
    Farkındalık: { title: 'Dönüşüm adımı ✦', body: (data) => `${data.days} gün... Bu gerçek bir dönüşüm. Devam ettiğinde… farkı göreceksin.`, duration: 7000 },
    Uyanış: { title: 'Dönüşüm adımı ✦', body: (data) => `${data.days} günlük süreklilik`, duration: 5000 },
    Dönüşüm: { title: '✦', body: (data) => `${data.days} gün`, duration: 3000 },
    Ustalık: null,
    Mentor: null
  },
  
  // === ZİHİN PUANI VE AŞAMA OLAYLARI ===
  [RHIE_EVENTS.XP_EARNED]: {
    Farkındalık: { title: 'Zihin puanı kazandın ✧', body: (data) => `+${data.xp} ZP... Her puan bir adım daha.`, duration: 4000 },
    Uyanış: { title: '+ZP', body: (data) => `${data.xp} ZP kazandın`, duration: 3000 },
    Dönüşüm: null,
    Ustalık: null,
    Mentor: null
  },
  [RHIE_EVENTS.LEVEL_UP]: {
    Farkındalık: { title: 'Yeni aşama ✦', body: (data) => `Lonca kapıları… hazır olduğunda açılır. Artık ${data.level} aşamasındasın.`, duration: 7000 },
    Uyanış: { title: 'Zihin aşaman yükseldi', body: (data) => `Yeni aşama: ${data.level}`, duration: 5000 },
    Dönüşüm: { title: '⬆️', body: (data) => data.level, duration: 3000 },
    Ustalık: { title: 'Aşama yükseldi', body: null, duration: 2000 },
    Mentor: null
  },
  [RHIE_EVENTS.BADGE_EARNED]: {
    Farkındalık: { title: 'Yeni rozet ◈', body: (data) => `"${data.badge}" rozetini kazandın... Usta sembolü… taşıyana sorumluluk yükler.`, duration: 6000 },
    Uyanış: { title: 'Rozet', body: (data) => data.badge, duration: 4000 },
    Dönüşüm: { title: '◈', body: null, duration: 2000 },
    Ustalık: null,
    Mentor: null
  },
  
  // === AI ÖNERİ OLAYLARI (P2 YENİ) ===
  [RHIE_EVENTS.AI_SUGGESTION_READY]: {
    Farkındalık: { title: 'Öneri hazır ◇', body: 'Bugün senin için özel bir telkin seçtim. Keşfetmek ister misin?', duration: 6000 },
    Uyanış: { title: 'Öneri', body: 'Bugünün telkini hazır.', duration: 4000 },
    Dönüşüm: null,
    Ustalık: null,
    Mentor: null
  },
  [RHIE_EVENTS.AI_RECOMMENDATION_SHOWN]: {
    Farkındalık: { title: 'Sana özel öneri ◈', body: (data) => data.reason || 'Bu telkin geçmiş tercihlerine göre seçildi.', duration: 5000 },
    Uyanış: { title: 'Öneri', body: 'Sana uygun bir seçim.', duration: 3000 },
    Dönüşüm: null,
    Ustalık: null,
    Mentor: null
  },
  
  // === DROP RİSK OLAYLARI ===
  [RHIE_EVENTS.AI_DROP_RISK_DETECTED]: {
    Farkındalık: { title: 'Seni özledik ◇', body: 'Belki şimdi değil… fakat geri döndüğünde kapı açık. Küçük bir adımla geri dönebilirsin.', duration: 7000 },
    Uyanış: { title: 'Geri dön', body: 'Yolculuğun seni bekliyor.', duration: 5000 },
    Dönüşüm: { title: 'Devam et', body: 'Bir nefes al, başla.', duration: 3000 },
    Ustalık: null,
    Mentor: null
  },
  [RHIE_EVENTS.DROP_RISK_MEDIUM]: {
    Farkındalık: { title: 'Nazik bir hatırlatma ∗', body: 'Ritüellerinden biraz uzaklaştın. Ritüel seni çağırıyor.', duration: 6000 },
    Uyanış: { title: 'Hatırlatma', body: 'Şimdi… bir nefes.', duration: 4000 },
    Dönüşüm: null,
    Ustalık: null,
    Mentor: null
  },
  [RHIE_EVENTS.DROP_RISK_HIGH]: {
    Farkındalık: { title: 'Motivasyonunu kaybetme ◈', body: 'Uzun süredir görüşemedik. Bugün… dönüşüm adımı.', duration: 7000 },
    Uyanış: { title: 'Geri dön', body: '5 dakika yeter.', duration: 4000 },
    Dönüşüm: null,
    Ustalık: null,
    Mentor: null
  },
  [RHIE_EVENTS.DROP_RISK_CRITICAL]: {
    Farkındalık: { title: 'Seninle konuşalım ◇', body: 'Uzun bir ara verdin. Bu bir kayıp değil… dönüşün başlangıcı.', duration: 8000 },
    Uyanış: { title: 'Özledik', body: 'Küçük bir adım at.', duration: 5000 },
    Dönüşüm: null,
    Ustalık: null,
    Mentor: null
  },
  [RHIE_EVENTS.DROP_RISK_RECOVERED]: {
    Farkındalık: { title: 'Geri döndün ✧', body: 'Harika... Aynı yere değil… daha bilinçli geri döndün.', duration: 6000 },
    Uyanış: { title: 'Hoş geldin', body: 'Yolculuğunu sürdür.', duration: 4000 },
    Dönüşüm: { title: '✧', body: null, duration: 2000 },
    Ustalık: null,
    Mentor: null
  },
  
  // === MOTİVASYON OLAYLARI ===
  [RHIE_EVENTS.MOTIVATION_LOW]: {
    Farkındalık: { title: 'Motivasyon düşük mü? ∗', body: 'Bazen böyle günler olur. Bu hata değil… mola. Yarın yeni bir gün.', duration: 6000 },
    Uyanış: { title: 'Hazırım', body: 'Dinlen, sonra devam et.', duration: 4000 },
    Dönüşüm: null,
    Ustalık: null,
    Mentor: null
  },
  [RHIE_EVENTS.MOTIVATION_BOOST_NEEDED]: {
    Farkındalık: { title: 'Sana özel bir öneri ◈', body: 'Bugün enerjini yükseltecek kısa bir telkin hazırladım.', duration: 5000 },
    Uyanış: { title: 'Enerji takviyesi', body: 'Daha derin seanslara kapı aç.', duration: 4000 },
    Dönüşüm: null,
    Ustalık: null,
    Mentor: null
  }
};

// ==========================================
// AI ÖNERİ SEBEP ŞABLONLARI
// ==========================================

const AI_REASON_TEMPLATES = {
  timeOfDay: {
    morning: 'Sabah enerjini yükseltmek için',
    noon: 'Gün ortası odaklanma için',
    evening: 'Akşam rahatlama için',
    night: 'Gece bilinçaltı programlama için'
  },
  mood: {
    stressed: 'Stresi azaltmak için sakinleştirici bir seçim',
    tired: 'Enerji seviyeni yükseltmek için',
    anxious: 'Kaygıyı azaltmak için derin nefes odaklı',
    focused: 'Odaklanmayı derinleştirmek için',
    default: 'Bugünün enerjisine uygun'
  },
  history: {
    favorite: 'En sevdiğin kategoriden',
    similar: 'Geçmiş tercihlerine benzer',
    new: 'Henüz keşfetmediğin bir içerik',
    repeat: 'Tekrar dinlemek isteyebileceğin'
  },
  streak: {
    maintain: 'Seriyi korumak için kısa bir ritüel',
    celebrate: 'Serini kutlamak için özel bir seçim',
    recover: 'Yeniden başlamak için motive edici'
  }
};

// ==========================================
// R.H.I.E. ENGINE CLASS (P2)
// ==========================================

class RHIEEngine {
  constructor() {
    // Core state
    this.token = null;
    this.user = null;
    this.userLevel = 'Farkındalık';
    this.initialized = false;
    
    // Ritual state
    this.dailyRitual = null;
    this.currentStreak = 0;
    this.longestStreak = 0;
    this.todayCompleted = false;
    this.lastActivityDate = null;
    this.totalSessions = 0;
    this.totalListenTime = 0;
    
    // AI state (P2)
    this.aiSuggestion = null;
    this.personalizedRecommendations = [];
    this.preferredCategories = [];
    this.preferredTimeOfDay = null;
    this.moodHistory = [];
    
    // Drop Risk state (P2)
    this.dropRiskScore = 0;
    this.dropRiskLevel = 'LOW';
    this.daysSinceLastActivity = 0;
    this.skipCount = 0;
    this.motivationScore = 100;
    
    // Guide state (P2)
    this.guideIntensity = GUIDE_INTENSITY.Farkındalık;
    this.hintsShownToday = 0;
    this.maxHintsPerDay = 10;
  }
  
  // ==========================================
  // INITIALIZATION
  // ==========================================
  
  async initialize(token, user) {
    this.token = token;
    this.user = user;
    this.userLevel = user?.rank || 'Farkındalık';
    this.guideIntensity = GUIDE_INTENSITY[this.userLevel] || GUIDE_INTENSITY.Farkındalık;
    
    console.log('[R.H.I.E.] Initializing P2 Engine...', { 
      userLevel: this.userLevel, 
      guideIntensity: this.guideIntensity 
    });
    
    // Fetch all initial data in parallel
    await Promise.all([
      this.fetchStreakData(),
      this.fetchUserHistory(),
      this.fetchDailyRitual(),
      this.calculateDropRisk()
    ]);
    
    // Generate personalized recommendations
    await this.generateRecommendations();
    
    this.initialized = true;
    console.log('[R.H.I.E.] P2 Engine initialized', {
      dropRiskScore: this.dropRiskScore,
      dropRiskLevel: this.dropRiskLevel,
      recommendations: this.personalizedRecommendations.length
    });
    
    // Check for immediate alerts
    this.checkDropRiskAlerts();
  }
  
  // ==========================================
  // GUIDE MESSAGE SYSTEM (Seviye Bazlı)
  // ==========================================
  
  shouldShowGuide() {
    // Check if guide should be shown based on level
    if (this.guideIntensity.level === 'off') return false;
    if (this.hintsShownToday >= this.maxHintsPerDay) return false;
    return true;
  }
  
  getGuideMessage(event, data = {}) {
    if (!this.shouldShowGuide()) return null;
    
    const messages = GUIDE_MESSAGES[event];
    if (!messages) return null;
    
    const message = messages[this.userLevel];
    if (!message) return null;
    
    // Handle dynamic body content
    let body = message.body;
    if (typeof body === 'function') {
      body = body(data);
    }
    
    return {
      title: message.title,
      body: body,
      duration: message.duration || 4000,
      event: event,
      level: this.userLevel,
      intensity: this.guideIntensity.level
    };
  }
  
  emitWithGuide(event, data = {}) {
    // Emit the main event
    rhieEventBus.emit(event, data);
    
    // Get and emit guide message if applicable
    const guideMessage = this.getGuideMessage(event, data);
    if (guideMessage) {
      this.hintsShownToday++;
      
      rhieEventBus.emit(RHIE_EVENTS.HINT_SHOWN, {
        hint: {
          id: `guide_${event}_${Date.now()}`,
          ...guideMessage,
          behavior: { autoDismissMs: guideMessage.duration },
          position: 'top-center'
        }
      });
    }
    
    return guideMessage;
  }
  
  // ==========================================
  // AI ÖNERİ MOTORU (P2)
  // ==========================================
  
  async fetchUserHistory() {
    if (!this.token) return;
    
    try {
      // Fetch user's playback history
      const response = await fetch(`${API_URL}/api/audio/history?limit=50`, {
        headers: { 'Authorization': `Bearer ${this.token}` }
      });
      
      if (response.ok) {
        const data = await response.json();
        if (data.success && data.data) {
          // Analyze preferences
          this.analyzePreferences(data.data);
        }
      }
    } catch (error) {
      console.error('[R.H.I.E.] Error fetching user history:', error);
    }
  }
  
  analyzePreferences(history) {
    if (!history || history.length === 0) return;
    
    // Count category preferences
    const categoryCounts = {};
    const timeCounts = { morning: 0, noon: 0, evening: 0, night: 0 };
    
    history.forEach(item => {
      // Category analysis
      const catId = item.category_id || item.session?.category_id;
      if (catId) {
        categoryCounts[catId] = (categoryCounts[catId] || 0) + 1;
      }
      
      // Time of day analysis
      if (item.played_at || item.created_at) {
        const hour = new Date(item.played_at || item.created_at).getHours();
        if (hour >= 5 && hour < 12) timeCounts.morning++;
        else if (hour >= 12 && hour < 17) timeCounts.noon++;
        else if (hour >= 17 && hour < 21) timeCounts.evening++;
        else timeCounts.night++;
      }
    });
    
    // Set preferred categories (top 3)
    this.preferredCategories = Object.entries(categoryCounts)
      .sort((a, b) => b[1] - a[1])
      .slice(0, 3)
      .map(([id]) => id);
    
    // Set preferred time
    const maxTime = Object.entries(timeCounts).sort((a, b) => b[1] - a[1])[0];
    this.preferredTimeOfDay = maxTime ? maxTime[0] : 'night';
    
    console.log('[R.H.I.E.] Preferences analyzed:', {
      preferredCategories: this.preferredCategories,
      preferredTimeOfDay: this.preferredTimeOfDay
    });
  }
  
  async generateRecommendations() {
    if (!this.token) return [];
    
    try {
      // Fetch available sessions
      const response = await fetch(`${API_URL}/api/audio/sessions?limit=20`, {
        headers: { 'Authorization': `Bearer ${this.token}` }
      });
      
      if (!response.ok) return [];
      
      const data = await response.json();
      if (!data.success || !data.data?.sessions) return [];
      
      const sessions = data.data.sessions;
      const recommendations = [];
      const currentHour = new Date().getHours();
      const timeOfDay = this.getTimeOfDayLabel(currentHour);
      
      // Score each session based on multiple factors
      sessions.forEach(session => {
        let score = 50; // Base score
        let reason = '';
        
        // 1. Time of day match (+20)
        if (this.isSessionGoodForTime(session, timeOfDay)) {
          score += 20;
          reason = AI_REASON_TEMPLATES.timeOfDay[timeOfDay];
        }
        
        // 2. Category preference match (+25)
        if (this.preferredCategories.includes(session.category_id)) {
          score += 25;
          reason = reason || AI_REASON_TEMPLATES.history.favorite;
        }
        
        // 3. Drop risk recovery boost (+15)
        if (this.dropRiskScore > 50 && session.duration_seconds <= 600) {
          score += 15; // Short sessions for recovery
          reason = reason || AI_REASON_TEMPLATES.streak.recover;
        }
        
        // 4. Streak maintenance bonus (+10)
        if (!this.todayCompleted && this.currentStreak > 0) {
          score += 10;
          reason = reason || AI_REASON_TEMPLATES.streak.maintain;
        }
        
        // 5. Variety bonus for new categories (+10)
        if (!this.preferredCategories.includes(session.category_id)) {
          score += 10;
          reason = reason || AI_REASON_TEMPLATES.history.new;
        }
        
        recommendations.push({
          session,
          score,
          reason: reason || AI_REASON_TEMPLATES.mood.default,
          source: 'ai_recommendation'
        });
      });
      
      // Sort by score and take top 5
      this.personalizedRecommendations = recommendations
        .sort((a, b) => b.score - a.score)
        .slice(0, 5);
      
      console.log('[R.H.I.E.] Recommendations generated:', this.personalizedRecommendations.length);
      
      return this.personalizedRecommendations;
    } catch (error) {
      console.error('[R.H.I.E.] Error generating recommendations:', error);
      return [];
    }
  }
  
  getTimeOfDayLabel(hour) {
    if (hour >= 5 && hour < 12) return 'morning';
    if (hour >= 12 && hour < 17) return 'noon';
    if (hour >= 17 && hour < 21) return 'evening';
    return 'night';
  }
  
  isSessionGoodForTime(session, timeOfDay) {
    const categoryMap = {
      morning: ['sabah-rituel', 'enerji', 'odak'],
      noon: ['odak-guc', 'berraklik', 'zihinsel-keskinlik'],
      evening: ['zihin-sakinligi', 'rahatlama'],
      night: ['gece-seremonisi', 'uyku', 'deep-sleep']
    };
    
    const categoryKey = session.category?.key || session.category_key || '';
    const goodCategories = categoryMap[timeOfDay] || [];
    
    return goodCategories.some(cat => categoryKey.includes(cat));
  }
  
  getTopRecommendation() {
    return this.personalizedRecommendations[0] || null;
  }
  
  getRecommendations(count = 3) {
    return this.personalizedRecommendations.slice(0, count);
  }
  
  acceptRecommendation(recommendation) {
    rhieEventBus.emit(RHIE_EVENTS.AI_RECOMMENDATION_ACCEPTED, {
      sessionId: recommendation.session?.id,
      reason: recommendation.reason,
      score: recommendation.score
    });
    
    // Set as daily ritual
    this.setDailyRitual(recommendation.session);
  }
  
  rejectRecommendation(recommendation) {
    rhieEventBus.emit(RHIE_EVENTS.AI_RECOMMENDATION_REJECTED, {
      sessionId: recommendation.session?.id
    });
    
    // Remove from recommendations
    this.personalizedRecommendations = this.personalizedRecommendations
      .filter(r => r.session?.id !== recommendation.session?.id);
  }
  
  // ==========================================
  // DROP RİSK ANALİZİ (P2)
  // ==========================================
  
  async calculateDropRisk() {
    let riskScore = 0;
    
    // Factor 1: Days since last activity (0-40 points)
    if (this.lastActivityDate) {
      const lastDate = new Date(this.lastActivityDate);
      const today = new Date();
      this.daysSinceLastActivity = Math.floor((today - lastDate) / (1000 * 60 * 60 * 24));
      
      if (this.daysSinceLastActivity > 14) riskScore += 40;
      else if (this.daysSinceLastActivity > 7) riskScore += 30;
      else if (this.daysSinceLastActivity > 3) riskScore += 20;
      else if (this.daysSinceLastActivity > 1) riskScore += 10;
    }
    
    // Factor 2: Streak broken (0-25 points)
    if (this.currentStreak === 0 && this.longestStreak > 3) {
      riskScore += 25; // Had a streak but broke it
    } else if (this.currentStreak === 0) {
      riskScore += 15; // Never had significant streak
    }
    
    // Factor 3: Skip count (0-20 points)
    if (this.skipCount > 5) riskScore += 20;
    else if (this.skipCount > 2) riskScore += 10;
    
    // Factor 4: Low completion rate (0-15 points)
    if (this.totalSessions > 0) {
      const avgListenTime = this.totalListenTime / this.totalSessions;
      if (avgListenTime < 300) riskScore += 15; // Less than 5 min average
      else if (avgListenTime < 600) riskScore += 8;
    }
    
    // Cap at 100
    this.dropRiskScore = Math.min(100, riskScore);
    
    // Determine risk level
    this.dropRiskLevel = this.getRiskLevel(this.dropRiskScore);
    
    console.log('[R.H.I.E.] Drop risk calculated:', {
      score: this.dropRiskScore,
      level: this.dropRiskLevel,
      daysSinceLastActivity: this.daysSinceLastActivity
    });
    
    return this.dropRiskScore;
  }
  
  getRiskLevel(score) {
    if (score >= DROP_RISK_LEVELS.CRITICAL.min) return 'CRITICAL';
    if (score >= DROP_RISK_LEVELS.HIGH.min) return 'HIGH';
    if (score >= DROP_RISK_LEVELS.MEDIUM.min) return 'MEDIUM';
    return 'LOW';
  }
  
  checkDropRiskAlerts() {
    if (this.dropRiskScore < 25) return; // Low risk, no alert
    
    // Emit appropriate risk event
    switch (this.dropRiskLevel) {
      case 'CRITICAL':
        this.emitWithGuide(RHIE_EVENTS.DROP_RISK_CRITICAL, {
          score: this.dropRiskScore,
          daysSince: this.daysSinceLastActivity
        });
        break;
      case 'HIGH':
        this.emitWithGuide(RHIE_EVENTS.DROP_RISK_HIGH, {
          score: this.dropRiskScore,
          daysSince: this.daysSinceLastActivity
        });
        break;
      case 'MEDIUM':
        this.emitWithGuide(RHIE_EVENTS.DROP_RISK_MEDIUM, {
          score: this.dropRiskScore,
          daysSince: this.daysSinceLastActivity
        });
        break;
    }
  }
  
  onActivityRecovered() {
    const previousLevel = this.dropRiskLevel;
    
    // Reset risk factors
    this.daysSinceLastActivity = 0;
    this.skipCount = Math.max(0, this.skipCount - 1);
    
    // Recalculate
    this.calculateDropRisk();
    
    // If recovered from high/critical, emit recovery event
    if ((previousLevel === 'HIGH' || previousLevel === 'CRITICAL') && 
        (this.dropRiskLevel === 'LOW' || this.dropRiskLevel === 'MEDIUM')) {
      this.emitWithGuide(RHIE_EVENTS.DROP_RISK_RECOVERED, {
        previousLevel,
        currentLevel: this.dropRiskLevel
      });
    }
  }
  
  getWinbackSuggestion() {
    // Return a short, easy session for users at high risk
    if (this.dropRiskScore < 50) return null;
    
    const shortSessions = this.personalizedRecommendations
      .filter(r => (r.session?.duration_seconds || 600) <= 420); // 7 min or less
    
    return shortSessions[0] || this.personalizedRecommendations[0];
  }
  
  // ==========================================
  // RITUAL MOTOR
  // ==========================================
  
  startRitual(session, source = 'browse') {
    this.emitWithGuide(RHIE_EVENTS.RITUAL_STARTED, {
      sessionId: session.id,
      sessionTitle: session.title,
      source
    });
    
    return true;
  }
  
  async completeRitual(session, actualListenedSeconds, completionPercentage) {
    const isValidCompletion = completionPercentage >= 80;
    
    if (!isValidCompletion) {
      return { success: false, message: 'Yetersiz dinleme süresi' };
    }
    
    // Calculate XP with bonuses
    const baseXP = session.base_xp || 15;
    const streakBonus = Math.min(this.currentStreak * 0.05, 0.5);
    const recoveryBonus = this.dropRiskScore > 50 ? 0.25 : 0; // Bonus for returning users
    const finalXP = Math.round(baseXP * (1 + streakBonus + recoveryBonus));
    
    // Update stats
    this.totalSessions++;
    this.totalListenTime += actualListenedSeconds;
    this.lastActivityDate = new Date().toISOString();
    
    // Emit completion
    this.emitWithGuide(RHIE_EVENTS.RITUAL_COMPLETED, {
      sessionId: session.id,
      sessionTitle: session.title,
      xpEarned: finalXP,
      completionPercentage,
      recoveryBonus: recoveryBonus > 0
    });
    
    // Handle streak
    const previousStreak = this.currentStreak;
    this.currentStreak += 1;
    this.todayCompleted = true;
    
    if (this.currentStreak > this.longestStreak) {
      this.longestStreak = this.currentStreak;
    }
    
    // Emit streak extended
    this.emitWithGuide(RHIE_EVENTS.STREAK_EXTENDED, {
      previousStreak,
      currentStreak: this.currentStreak
    });
    
    // Check milestones
    const milestones = [7, 21, 30, 66, 100];
    if (milestones.includes(this.currentStreak)) {
      this.emitWithGuide(RHIE_EVENTS.STREAK_MILESTONE, {
        days: this.currentStreak
      });
    }
    
    // Emit XP
    this.emitWithGuide(RHIE_EVENTS.XP_EARNED, {
      xp: finalXP,
      source: 'ritual_completion'
    });
    
    // Handle recovery
    if (this.dropRiskScore > 50) {
      this.onActivityRecovered();
    }
    
    return {
      success: true,
      xpEarned: finalXP,
      currentStreak: this.currentStreak,
      isMilestone: milestones.includes(this.currentStreak),
      recoveryBonus: recoveryBonus > 0
    };
  }
  
  skipRitual(session, reason = 'user_choice') {
    this.skipCount++;
    
    this.emitWithGuide(RHIE_EVENTS.RITUAL_SKIPPED, {
      sessionId: session?.id,
      reason
    });
    
    // Recalculate risk after skip
    this.calculateDropRisk();
  }
  
  // ==========================================
  // DAILY RITUAL
  // ==========================================
  
  async fetchDailyRitual() {
    if (!this.token) return null;
    
    try {
      const response = await fetch(`${API_URL}/api/audio/today-suggestion`, {
        headers: { 'Authorization': `Bearer ${this.token}` }
      });
      const data = await response.json();
      
      if (data.success && data.data?.session) {
        this.dailyRitual = data.data.session;
        this.aiSuggestion = data.data;
        
        rhieEventBus.emit(RHIE_EVENTS.DAILY_RITUAL_ASSIGNED, {
          ritual: this.dailyRitual,
          reason: data.data.reason || 'ai_recommendation'
        });
        
        return this.dailyRitual;
      }
    } catch (error) {
      console.error('[R.H.I.E.] Error fetching daily ritual:', error);
    }
    return null;
  }
  
  setDailyRitual(session) {
    this.dailyRitual = session;
    rhieEventBus.emit(RHIE_EVENTS.DAILY_RITUAL_ASSIGNED, {
      ritual: session,
      reason: 'manual_override'
    });
  }
  
  // ==========================================
  // STREAK MOTOR
  // ==========================================
  
  async fetchStreakData() {
    if (!this.token) return null;
    
    try {
      const response = await fetch(`${API_URL}/api/audio/streak`, {
        headers: { 'Authorization': `Bearer ${this.token}` }
      });
      const data = await response.json();
      
      if (data.success && data.data) {
        this.currentStreak = data.data.current_streak || 0;
        this.longestStreak = data.data.longest_streak || 0;
        this.todayCompleted = data.data.completed_today || false;
        this.lastActivityDate = data.data.last_activity_date;
        this.totalSessions = data.data.total_sessions || 0;
        this.totalListenTime = (data.data.total_listen_time_minutes || 0) * 60;
        
        // Check streak at risk (evening time, not completed)
        const hour = new Date().getHours();
        if (!this.todayCompleted && hour >= 18 && this.currentStreak > 0) {
          this.emitWithGuide(RHIE_EVENTS.STREAK_AT_RISK, {
            currentStreak: this.currentStreak
          });
        }
        
        return data.data;
      }
    } catch (error) {
      console.error('[R.H.I.E.] Error fetching streak:', error);
    }
    return null;
  }
  
  // ==========================================
  // GAMIFICATION
  // ==========================================
  
  awardXP(amount, source) {
    this.emitWithGuide(RHIE_EVENTS.XP_EARNED, { xp: amount, source });
  }
  
  levelUp(newLevel) {
    this.userLevel = newLevel;
    this.guideIntensity = GUIDE_INTENSITY[newLevel] || this.guideIntensity;
    
    this.emitWithGuide(RHIE_EVENTS.LEVEL_UP, { level: newLevel });
    
    // Emit guide intensity change
    rhieEventBus.emit(RHIE_EVENTS.GUIDE_INTENSITY_CHANGED, {
      level: newLevel,
      intensity: this.guideIntensity
    });
  }
  
  awardBadge(badgeName, badgeId) {
    this.emitWithGuide(RHIE_EVENTS.BADGE_EARNED, { badge: badgeName, badgeId });
  }
  
  // ==========================================
  // GETTERS
  // ==========================================
  
  getDailyRitual() { return this.dailyRitual; }
  getCurrentStreak() { return this.currentStreak; }
  getLongestStreak() { return this.longestStreak; }
  isTodayCompleted() { return this.todayCompleted; }
  getAISuggestion() { return this.aiSuggestion; }
  getDropRiskScore() { return this.dropRiskScore; }
  getDropRiskLevel() { return this.dropRiskLevel; }
  getUserLevel() { return this.userLevel; }
  getGuideIntensity() { return this.guideIntensity; }
  getPersonalizedRecommendations() { return this.personalizedRecommendations; }
  getDaysSinceLastActivity() { return this.daysSinceLastActivity; }
  getMotivationScore() { return this.motivationScore; }
}

// Singleton instance
export const rhieEngine = new RHIEEngine();

export default rhieEngine;
